module.exports = __webpack_public_path__ + "img/usability.4fe282f7.png";